import { APP_LANGUAGES } from '../app.config.vars/languages';
import { formatLangCode } from '../helpers';
import i18n from '../translations/i18n';
export const getCurrentLangId = () => APP_LANGUAGES.find((lang) => lang.code === formatLangCode(i18n.language))?.backendNumber || '0';
